import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { Container, Row, Col, Nav, Navbar, Image } from 'react-bootstrap';
import { footerData } from '../Data/data';
import Paragraph from './Paragraph';

const Footer = () => {
  return (
    <Navbar role="contentinfo" sticky="bottom" expand={false} className='footer'>
        <Container className="col-sm-6 col-lg-2 footerTexts">
            <Row className="w-100 m-auto">
              <Col sm={2} lg={2} className="">
                <FontAwesomeIcon icon={faHome} className="" />
              </Col>
              <Col sm={10} lg={10} className="">
                <Paragraph classes={""} text={footerData.contactName} />
              </Col>
            </Row>
            <Row className="w-100 m-auto">
              <Col sm={2} lg={2} className="">
                <FontAwesomeIcon icon={faEnvelope} className="" />
              </Col>
              <Col sm={10} lg={10} className="">
                <Paragraph classes={""} text={footerData.contactEmail} />
              </Col>
            </Row>
        </Container>
        <Container className="col-sm-12 col-lg-7 text-center">
          <Nav.Link href={footerData.footerLinks.karhuseutu} className="col-sm-6 col-lg-3 footerLink" ><Image src={footerData.footerImages.karhuseutu} alt={footerData.footerAlts.karhuseutu} className="footerLogo" /></Nav.Link>
          <Nav.Link href={footerData.footerLinks.vipuvoima} className="col-sm-6 col-lg-3 footerLink" ><Image src={footerData.footerImages.vipuvoima} alt={footerData.footerAlts.vipuvoima} className="footerLogo" /></Nav.Link>
          <Nav.Link href={footerData.footerLinks.eu} className="col-sm-6 col-lg-3 footerLink" ><Image src={footerData.footerImages.eu} alt={footerData.footerAlts.eu} className="footerLogo" /></Nav.Link>
          <Nav.Link href={footerData.footerLinks.pori} className="col-sm-6 col-lg-3 footerLink" ><Image src={footerData.footerImages.pori} alt={footerData.footerAlts.pori} className="footerLogo" /></Nav.Link>
        </Container>
        <Container className="col-lg-2 footerTexts">
          <Paragraph classes={"m-auto"} text={footerData.versionInfo} />
        </Container>
    </Navbar>
  );
};

export default Footer;